// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"SunburstChart-primaryButton-3I4gWr","chartWrapper":"SunburstChart-chartWrapper-2w11nO","tooltip":"SunburstChart-tooltip-2moylu"};